export const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const validatePhone = (phone) => {
  const phoneRegex = /^[+]?[\d\s()-]{10,}$/;
  return phoneRegex.test(phone);
};

export const validateAmount = (amount) => {
  const numAmount = parseFloat(amount);
  return !isNaN(numAmount) && numAmount >= 100;
};

export const validateRequired = (value) => {
  return value && value.toString().trim().length > 0;
};

export const validatePAN = (pan) => {
  if (!pan) return true; // PAN is optional
  const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
  return panRegex.test(pan.toUpperCase());
};

export const getValidationErrors = (formData, requiredFields) => {
  const errors = {};
  
  requiredFields.forEach(field => {
    if (!validateRequired(formData[field])) {
      errors[field] = `${field} is required`;
    }
  });
  
  if (formData.email && !validateEmail(formData.email)) {
    errors.email = 'Please enter a valid email address';
  }
  
  if (formData.phone && !validatePhone(formData.phone)) {
    errors.phone = 'Please enter a valid phone number';
  }
  
  if (formData.amount && !validateAmount(formData.amount)) {
    errors.amount = 'Amount must be at least ₹100';
  }
  
  if (formData.pan && !validatePAN(formData.pan)) {
    errors.pan = 'Please enter a valid PAN number';
  }
  
  return errors;
};